(function () {
  function initCard3D(cardEl) {
    var mv = cardEl.querySelector('.card__model-viewer');
    if (!mv || mv._card3dInit) return;
    mv._card3dInit = true;
    var theta = 0;
    var rafId;

    cardEl.addEventListener('mouseenter', function () {
      mv.style.opacity = '1';
      cancelAnimationFrame(rafId);
      function animate() {
        theta = (theta + 0.8) % 360;
        try { mv.cameraOrbit = theta + 'deg 75deg auto'; } catch(e) {}
        rafId = requestAnimationFrame(animate);
      }
      animate();
    });

    cardEl.addEventListener('mouseleave', function () {
      cancelAnimationFrame(rafId);
      mv.style.opacity = '0';
    });
  }

  function init() {
    document.querySelectorAll('.card-wrapper').forEach(initCard3D);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) {
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.classList && node.classList.contains('card-wrapper')) {
          initCard3D(node);
        }
        if (node.querySelectorAll) {
          node.querySelectorAll('.card-wrapper').forEach(initCard3D);
        }
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();
